import { Controller, useFormContext } from 'react-hook-form';
import { Briefcase01 } from '@untitledui/icons';
import { Input } from '@/components/base/input/input';
import { AUTH_FORM_SIZE } from '@/shared/config/auth-form';
import type { SignupFormValues } from '../schema';

export const Step05Cargo = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="cargo"
      render={({ field }) => (
        <Input
          label="Cargo"
          type="text"
          size={AUTH_FORM_SIZE}
          icon={Briefcase01}
          placeholder="Ex.: CEO, Diretora Comercial"
          autoComplete="organization-title"
          autoFocus
          isInvalid={!!errors.cargo}
          hint={errors.cargo?.message}
          value={field.value ?? ''}
          onChange={field.onChange}
          onBlur={field.onBlur}
          name={field.name}
        />
      )}
    />
  );
};
